module.exports = __webpack_public_path__ + "img/MAC1132_1-1.73b058f4.jpg";